import React from 'react';
import styled from 'styled-components';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { DECORATORS } from 'shared/design-system/settings/variables/Decorators';

interface FeedbackBottomBarProps {
  handlePrevious: () => void;
  handleNext: () => void;
  selectedIndex: number;
  isDone: boolean;
  isLastIndex: boolean;
}

const StyledDiv = styled.div`
  display: flex;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  gap: ${SPACERS.medium};
  justify-content: space-between;
  padding: 14px ${SPACERS.large};
  background-color: ${COLORS.grayLightest};
  box-shadow: ${DECORATORS.boxShadowDefault};
  .feedback-bottom-button {
    flex: 1;
    max-width: 250px;
  }
`;

const FeedbackBottomBar: React.FC<FeedbackBottomBarProps> = ({
  handlePrevious,
  handleNext,
  selectedIndex,
  isDone,
  isLastIndex,
}) => {
  return (
    <StyledDiv>
      <TrueImpactButton
        disabled={selectedIndex === 0}
        variant="secondary-large"
        className="feedback-bottom-button"
        onClick={handlePrevious}
      >
        Previous Feedback Item
      </TrueImpactButton>
      <TrueImpactButton
        disabled={!isDone && isLastIndex}
        variant="primary-large"
        className="feedback-bottom-button"
        onClick={handleNext}
      >
        Next Feedback Item
      </TrueImpactButton>
    </StyledDiv>
  );
};

export default FeedbackBottomBar;
